export const darkBlue = '#125773';
export const mediumTurquoise = '#33CCCC';
export const darkOrange = '#E7923D';
export const lightOrange = '#ED7D31';
export const black = '#0D0D0D';
export const lightPink = 'rgba(105, 37, 93, 0.5)';
export const lighterPink = 'rgba(105, 37, 93, 0.25)';
export const periWinkle = '#CED4EA';
export const grey = '#7F7F7F';
export const darkGrey = '#202020';
export const lightGrey = '#d1d0d0';
export const brightGray = '#3A3C4B';
export const lighterGrey = '#F0F0F0';
export const overlayColor = '#DDD';
export const turquoise = '#33CCCC';
export const twilight = '#E4C9E4';
export const silver = '#afabab';
export const whiteLilac = '#F9FAFD';
export const lightTurquoise = 'rgba(51,204,204,0.25)';
export const white = '#FFFFFF';
export const red = '#ff00008c';

export const AppointmentColors = {
  call: turquoise,
  meeting: twilight,
  assignment: silver,
};
